import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import closeIcon from "../../../../../assets/icons/dashboard-x-close.svg";
import React from "react";
import ImageGroupForm from "../../ImageGroupForm/ImageGroupForm";

function ImageGroupModal({ id, open, handleClose, data, ...rest }) {
  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {}}
      className="ta-modal dashboard-image-group-modal"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "829px"
          }
        }
      }}
    >
      <DialogTitle id="alert-dialog-title" className="modal_title">
        <span className="label">
          {data?.isEdit ? "Edit Desktop Group" : "Add a New Desktop Group"}
        </span>
        <span className="close-btn" onClick={() => handleClose(id)}>
          <img src={closeIcon} alt="" />
        </span>
      </DialogTitle>
      <p className="subtitle">
        {data?.isEdit
          ? "Let's update an existing desktop group"
          : "Let's Create a new desktop group together"}
      </p>

      <DialogContent className="ta-modal-content-scroll">
        <ImageGroupForm
          isEdit={data?.isEdit || false}
          id={data?.isEdit ? data?.id : null}
          group={data?.isEdit ? data?.group : null}
        />
      </DialogContent>
    </Dialog>
  );
}

export default ImageGroupModal;
